export default "__VITE_ASSET__86958271__"